import { mapPaymentError } from './payment-error.mapper';
import { IPaymentError } from './payment-error.types';

export const getPaymentErrorMessage = (error: IPaymentError): string | undefined => {
    const mappedError = mapPaymentError(error);
    return mappedError?.userMessage;
};
